import React from 'react'
import ReactDOM from 'react-dom'
import AlertList from './Staticize'
import AlertListMiniAppset from './MiniAppSet'
import AlertListCustom from './AlertListCustom'
import { BsyUtils } from '../../utils/Utils'

const BsyAlertListDetail = props =>
    new Promise((fulfill) => { // 此处参数需用圆括号，否则 eslint 报错
        document.getElementsByTagName('body')[0].style.overflow = "hidden";
        let clsName = props.clsName || "BsyAlertListDetail";
        let holder
        // if(document.getElementsByClassName(clsName).length>0){
        //     document.getElementsByClassName(clsName)[0].removeChild(document.getElementsByClassName(clsName)[0].firstChild);
        //     holder = document.getElementsByClassName(clsName)[0]
        // }else{
        //     holder = document.createElement('div');
        //     holder.classList.add(clsName);
        //     holder.style.zIndex = window.FX.STATIC.zIndex++;
        //     document.body.appendChild(holder);
        // }
        holder = document.createElement('div');
        holder.classList.add(clsName);
        holder.style.zIndex = window.FX.STATIC.zIndex++;
        document.body.appendChild(holder);

        let rootTokenClass = 'rootTokenCls'+ (new Date()).getTime()
        holder.classList.add(rootTokenClass);
        let holderTo = document.createElement('div');
        holderTo.classList.add("alertListDetailContent");
        setTimeout(()=>{
            holder.classList.add("fadein");
        },30)
        holder.onclick = (event) =>{
            event.stopPropagation()
        }
        holder.appendChild(holderTo)

        // let timer = setTimeout(()=>{
        //     holder.removeChild(holderTo)
        //     ReactDOM.unmountComponentAtNode(holderTo)
        //     if(document.getElementsByClassName("alertImgCodeContent").length<=0){
        //         document.body.removeChild(holder)
        //         ReactDOM.unmountComponentAtNode(holder)
        //     }
        //     clearInterval(timer)
        // },3000)

        // if(document.getElementsByClassName(clsName).length>1){
        //     holder.removeChild(holderTo)
        //     ReactDOM.unmountComponentAtNode(holderTo)
        //     // clearInterval(timer)
        // }

        let CleanRootNode = (e)=>{
            // 当界面被点击时自动清理元素
            // e 为null，组件自己清理自己 
            // 无法找到父级元素 rootTokenClass 说明点击了其他任意位置

            // x-dropdown 旧的日历控件临时使用，控件优化完之后需要删除 //bsy-x-window-mask
            if(e && (BsyUtils.closestClass(e.target,'x-dropdown') || BsyUtils.closestClass(e.target,'bsy-datepicker') || BsyUtils.closestClass(e.target,'x-window-mask') || BsyUtils.closestClass(e.target,'bsy-x-window-mask'))) 
                return;
            if(!e || !BsyUtils.closestClass(e.target,rootTokenClass) ) {
                document.getElementsByTagName('body')[0].style.overflow = ""
                holder.removeChild(holderTo)
                ReactDOM.unmountComponentAtNode(holderTo)
                holder.remove();
                // document.removeEventListener('mouseup', CleanRootNode, false);
            } 
        }
        holder.onclick = function(event){
            if(event.target.classList[0] === "alertListDetailContent"){
                CleanRootNode();
            }
        }

        // document.addEventListener('mouseup', CleanRootNode, false);
        
        const newProps={...props,target:holderTo}
        holder.style.width = '100%';
        newProps.onRemoveRoot = ()=>{
            //自动清理
            CleanRootNode();
        }
        
        switch(newProps.type) {
            case 'miniAppSet':{
                ReactDOM.render(
                    <AlertListMiniAppset
                        {...newProps}
                    />,
                    holderTo
                )
                break;
            }
            case 'custom':{
                ReactDOM.render(
                    <AlertListCustom
                        {...newProps}
                    />,
                    holderTo
                )
                break;
            }
            default:{
                ReactDOM.render(
                    <AlertList
                        {...newProps}
                    />,
                    holderTo
                )
            }
        }

        // ReactDOM.render(
        //     <AlertList
        //         {...newProps}
        //     />,
        //     holderTo
        // )
    }).catch(res => {
        console.error('BsyAlertListDetail',res);
    })

export default BsyAlertListDetail